import React, { useState } from 'react'
import { Box, Tab, Tabs, Typography } from '@mui/material'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined'
import AddressQualityDashboard from './AddressQualityDashboard'
import RtoRiskDashboard from './RtoRiskDashboard'

/**
 * NETRA Intelligence — the admin calibration console for both ML signals that
 * ride on an order. Address Quality and RTO Risk are scored by the same NETRA
 * service and persisted side-by-side on the netra_score document, so they live
 * under one screen as sibling tabs rather than two routes.
 *
 * The tab content components ({@link AddressQualityDashboard}, {@link RtoRiskDashboard})
 * are self-contained (own filters + data loads); this wrapper only owns the
 * heading and tab strip. Both are gated INTERNAL by the route.
 */
const NetraIntelligenceDashboard = () => {
  const [tab, setTab] = useState(0)

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant='h5' fontWeight={700}>NETRA Intelligence</Typography>
      <Typography variant='body2' color='text.secondary'>
        Model score vs. real outcome — verify accuracy and capture ground-truth feedback across both signals.
      </Typography>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mt: 1, mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tab icon={<PlaceOutlinedIcon fontSize='small' />} iconPosition='start' label='Address Quality' />
        <Tab icon={<AssignmentReturnOutlinedIcon fontSize='small' />} iconPosition='start' label='RTO Risk' />
      </Tabs>

      {/* Mount only the active tab so each loads its own data lazily on entry. */}
      {tab === 0 && <AddressQualityDashboard embedded />}
      {tab === 1 && <RtoRiskDashboard />}
    </Box>
  )
}

export default NetraIntelligenceDashboard
